import React from 'react';
import BaseComponent from '../components/BaseComponent';
import { GetQuiteDetails, Statistics } from '../common/ApiHelper';
import {H5VideoManager} from '../common/H5VideoManger';
import AsyncImg from '../components/AsyncImgComponent';
import Back from '../components/BackComponent';

import {
    Player,
    ControlBar,
    PlayToggle, // PlayToggle 播放/暂停按钮 若需禁止加 disabled
    ReplayControl, // 后退按钮
    ForwardControl,  // 前进按钮
    CurrentTimeDisplay,
    TimeDivider,
    PlaybackRateMenuButton,  // 倍速播放选项
    VolumeMenuButton
  } from 'video-react';
  import "../../node_modules/video-react/dist/video-react.css";
class Video extends BaseComponent {
    state: {
        Data: QuiteDetails['Data']['bookDetails'],
        playIndex: number,
    } = {
        Data: {
            ClassifyTitle: '',
            collect: 0,
            sectionList: [],
            bookID: 0,
            imgUrl: '',
            name: '',
            writer: '',
            lookCount: 0,
            downCount: 0,
            intro: ''
        },
        playIndex: 0
    }
    public player:any;
    public videoManager: H5VideoManager;
    public first = true;
    public bookId = 0;
    constructor(props: any) {
        super(props);
        this.videoManager = new H5VideoManager();
        this.videoManager.onEnded(()=>{
            this.onNext();
        });
    }
    componentWillUnmount() {
        this.RemoveToast();
        delete this.videoManager;
    }
    componentDidMount() {
        const bookid = this.GetQueryString(this.props.location.search,'bookid')!;
        this.bookId = parseInt(bookid);
        this.ShowToast();
        GetQuiteDetails(bookid, (res)=>{
            if (res.ResultCode !== 0) {
                this.RemoveToast();
                this.ShowToast(res.Msg, 1, 3000);
                return;
            }
            const src = res.Data.bookDetails.sectionList[this.state.playIndex].fileUrl;
            this.videoManager!.src = src;
            this.videoManager!.poster=res.Data.bookDetails.imgUrl;
            this.setState({Data: res.Data.bookDetails}, ()=>{
                this.RemoveToast();
                this.InitReadHistory();
            });
        });
        jQuery(".c-slide").slide();
    }
    public onItemClick = (src: string, index: number) => {
        this.play(src);
        this.setState({playIndex: index})
    }
    public play = (src?: string) => {
        if (src !== undefined) {
            this.videoManager.src = src;
        }
        if (this.first) {
            this.first = false;
            Statistics(this.state.Data.bookID , 1, () => {
                this.state.Data.lookCount += 1;
            });
        }
        this.SaveReadHistory();
    }
    public onPre = () => {
        const preIndex = this.state.playIndex - 1;
        if (preIndex < 0) return;
        this.play(this.state.Data.sectionList[preIndex].fileUrl);
        this.setState({ playIndex: preIndex });
    }
    public onNext = () => {
        const nextIndex = this.state.playIndex + 1;
        if (nextIndex > this.state.Data.sectionList.length - 1) return;
        this.play(this.state.Data.sectionList[nextIndex].fileUrl);
        this.setState({ playIndex: nextIndex });
    }
    /**
     * 保存阅读记录
     */
    public SaveReadHistory = () => {
        const history = {
            playIndex: this.state.playIndex
        }
        localStorage.setItem(this.bookId.toString(), JSON.stringify(history));
    }
    public InitReadHistory = () => {
        const historyItem = localStorage.getItem(this.bookId.toString());
        if (historyItem !== null) {
            const history = JSON.parse(historyItem) as {playIndex: number};
            if (history.playIndex !== 0) {
                this.ShowToast('是否跳转到上次播放记录?', 2, 0, () => {
                    this.RemoveToast();
                }, () => {
                    this.setState({playIndex: history.playIndex}, ()=>{
                        this.RemoveToast();
                        this.videoManager.src = this.state.Data.sectionList[this.state.playIndex].fileUrl;
                        const dom = document.querySelector('dl > dd.on');
                        dom!.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
                    });
                });
            }
        }
    }
    public back = () => {
        this.props.history.goBack();
    }
    public onPlayClick=()=>{
       if( this.player.getState().player.paused){
           this.player.video.play()
       }else{
           this.player.video.pause()
       }
    }
    public render() {
        const {playIndex } = this.state;
        const { ClassifyTitle, collect, sectionList, bookID, imgUrl, name, writer, lookCount, downCount, intro } = this.state.Data;
        const sectionListLayout = sectionList.map((v, i)=>{
            return <dd className={i === playIndex ? 'on' : ''} key={v.id} onClick={this.onItemClick.bind(this, v.fileUrl, i)}>
                <a>
                    <div className="c-img"><AsyncImg src={imgUrl} /></div>
                    <div className="c-tit">
                        <h1>{v.name}</h1>
                        <h2>{'大小：' + v.size}</h2>
                    </div>
                </a>
            </dd>
        });
        if(this.videoManager.src!=""){
            return (
                <div className="c-box">
                     <Back onBackClick={this.back}/>
                    <div className="c-tingshuxq">
                        <div className="mt" style={{padding:'0'}}>
                            <Player ref={(c:any)=> {
                                this.player = c;
                                }}  poster={this.videoManager.poster}>  
                                <source
                                src={this.videoManager.src}
                                type="video/mp4"
                                />
                                <ControlBar autoHide={true} disableDefaultControls={false}>
                                <ReplayControl seconds={10} order={1.1} />
                                <ForwardControl seconds={30} order={1.2} />
                                <PlayToggle />
                                <CurrentTimeDisplay order={4.1} />
                                <TimeDivider order={4.2} />
                                <PlaybackRateMenuButton rates={[5, 2, 1.5, 1, 0.5]} order={7.1} />
                                <VolumeMenuButton />
                                </ControlBar>
                            </Player>
                            <div className="c-tit">
                                <h1>{name}</h1>
                                <p>{'栏目：' + ClassifyTitle}</p>
                                <p>{'收听量：' + lookCount}</p>
                                {/* <div className="c-tit">收藏</div> */}
                            </div>
                        </div>
                        <div className="mc">
                            <ul>
                                <li>
                                    <a onClick={this.onPlayClick}>
                                        <div className="c-img"><img src={require('../img/play.png')} /></div>
                                        <div className="c-tit">收听</div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="mb">
                            <div className="c-slide">
                                <div className="hd">
                                    <ul>
                                        <li>简介</li>
                                        <li className="on">目录</li>
                                    </ul>
                                </div>
                                <div className="bd">
                                    <ul>
                                        <li>
                                            <div className="c-jianjie">
                                                {intro}
                                            </div>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            <div className="c-t">{'共' + (sectionList.length - 1) + '章'}</div>
                                            <dl style={{WebkitOverflowScrolling: 'touch'}}>
                                               {sectionListLayout}
                                            </dl>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }else{
            return (<div></div>);
        }
    }
}
export default Video;
